import { Text } from "@mantine/core";
import { EntityClientAction, openEntityForm } from "@mcurros2/microm";
import { SolicitudesRuteoImportacion } from "./SolicitudesRuteoImportacion/SolicitudesRuteoImportacion";
import { SolicitudesRuteoImportacionProceso } from "./SolicitudesRuteoImportacionProceso/SolicitudesRuteoImportacionProceso";

export const ACTImportarRutas: EntityClientAction = {
    name: 'ACTImportarRutas',
    label: 'Importar Rutas',
    title: <Text fw={700}>Editar ruta</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    views: ['soru_brwDisponibleEnRutas'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return false;
        }

        const solicitudesRuteoImportacion = new SolicitudesRuteoImportacion(entity.API.client);

        const proceso_id = await new Promise<string | null>(async (resolve) => {

            await openEntityForm({
                modals: modal,
                formProps: {
                    entity: solicitudesRuteoImportacion,
                    initialFormMode: 'add',
                    getDataOnInit: false,
                },
                modalFormSize: 'xl',

                handleModalSaved: async (result) => {
                    const status = result.data?.Results?.[0]?.Status;
                    const message = result.data?.Results?.[0]?.Message;

                    if (status === 0) {
                        resolve(message ?? null);
                    } else {
                        resolve(null);
                    }
                },

                handleModalCancel: async () => {
                    resolve(null);
                }
            });
        });

        await modal.close();
        if (onClose) await onClose();

        if (proceso_id) {
            const solicitudesRuteoImportacionProceso = new SolicitudesRuteoImportacionProceso(entity.API.client);
            solicitudesRuteoImportacionProceso.def.columns.c_proceso_id.value = proceso_id;

            await openEntityForm({
                modals: modal,
                formProps: {
                    entity: solicitudesRuteoImportacionProceso,
                    initialFormMode: 'view',
                    getDataOnInit: true,
                },
                modalFormSize: 'xl',

                handleModalSaved: async () => {
                    await modal.close();
                    if (onClose) await onClose();
                },

                handleModalCancel: async () => {
                    await modal.close();
                    if (onClose) await onClose();
                }
            });
        }

        return false;
    }
}